<template>
  <header class="ut-fc header">
    <div class="top-bar">
      <div class="top-bar-inner">
        <div class="logo">
          <div class="logo-box">
            <img
              class="img-responsive company-logo"
              :src="`https://detailss3web.s3.amazonaws.com/images/logo/${this.clientName}logo`"
              alt
            />
          </div>
        </div>

        <SwitchButton @switchValueChanged="onChangeSwitchValue()" />

        <div class="language-box">
          <Dropdown
            :showLabel="false"
            :options="languagesTV"
            :selected="languagesTV.find((e) => e.value == language)"
            v-on:selectedChange="(e) => onLanguageChange(e)"
            :style="{
              color: 'white',
            }"
          ></Dropdown>
        </div>
      </div>
    </div>
    <div class="page-header-inner">
      <div class="page-header">
        <slot name="pageTitle">
          <span> Page Title </span>
        </slot>

        <div class="buton-group v1">
          <button
            class="dt-button v1"
            v-if="!submitButtonFlag"
            @click="onSubmit"
          >
            {{ $t("submit") }}
          </button>
          <span v-else>Your data has succesfully been transferred</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import SwitchButton from "./switch-button";

export default {
  name: "Header",
  components: {
    SwitchButton,
  },
  props: ["clientName", "language", "languagesTV", "submitButtonFlag"],
  data() {
    return {};
  },
  computed: {},
  methods: {
    onLanguageChange(e) {
      this.$emit("languageChanged", e);
    },
    onChangeSwitchValue() {
      this.$emit("switchValueChanged");
    },
    onSubmit() {
      this.$emit("submit");
    },
  },
};
</script>